import $ from 'jquery';
import fullpage from 'fullpage.js';
import * as utils from './utils.js';
import { getParam } from 'utilsES';
import * as api from './api.js';
import * as fbUtils from './fb.js';
import language from './language';

let menuHasClick = false;
let initPage = false;

//缓存的信息
let informationForm = {    
    phone_merge: localStorage.getItem('phone_merge'),
    email: localStorage.getItem('email'),
};

export const common = {
    init(fullpageAPI) {
    //立即预约
    $('.j-go-appointment').on('click', e => {
      fullpageAPI.moveTo(2);
    });
    $('.j-go-part4').on('click', e => {
        fullpageAPI.moveTo(4);
    });
    $('.j-language-btn').on('click', e => {
        $('.j-language-list').toggle()
    });
    $(".j-language-list").on("click", ".language-item", function () {
        const lang = $(this).data("language");
        language.changeLang(lang);
        $(".j-language-selected").html(language.getText('languageSelected'));
        $('.j-language-list').hide();
    }); 
  },
};

export const menu = {
  navList: $('.j-desc-list li'),
  fullpageAPI: null,
  init(fullpageAPI) {
    const $nav = $('.j-nav');
    const $navMenu = $('.j-nav-menu');
    const $descList = $('.j-desc-list');
    const $navClose = $('.j-nav-close');
    this.fullpageAPI = fullpageAPI;
    this.navList.eq(0).addClass('active');

    $navMenu.on('click', () => {
      menuHasClick = true;
      $nav.addClass('active');
    });
    $navClose.on('click', () => {
      $nav.removeClass('active');
    });
    $descList.on('click', ({ target }) => {
      if (!target.dataset.index) {
        return;
      }
      const index = target.dataset.index * 1;
      fullpageAPI.moveTo(index);
    });
  },
  changePage(index) {
    this.fullpageAPI.moveTo(index);
    this.navList
      .removeClass('active')
      .eq(index - 1)
      .addClass('active');
  },
};

export const wakeNum = {
  $remainNum: $('.j-remain-num'),
  init() {
    informationForm.phone_merge = localStorage.getItem('phone_merge');
    informationForm.email = localStorage.getItem('email');
    this.update();
  },
  update() {
    api
      .req('basic',informationForm)
      .then(({ data }) => {
        this.$remainNum.text(data.lottery_chance);
      })
      .catch(err => {
        this.$remainNum.text(0);
      });
  },
};

export const share = {
  center: false,
  init() {
    this.event();
    this.getShareTimeToHide() && $('.j-fb-share').removeClass('zan');
  },
    shareFB() {
        // 记住今天最后时间
        this.setFinalTime();
        fbUtils.share();
  },
  centerDialog() {
    if (!this.center) {
      try {
        this.center = true;
        // 对话框居中
        const handleListenChange = (mutationsList, observer) => {
          $('.fb_dialog').each((index, ele) => {
            const $dialog = $(ele);
            const top = parseInt($dialog.css('top'));
            if (top > 0) {
              const windowWidth = window.innerWidth;
              const windowHight = window.innerHeight;
              const dialogWidth = $dialog.width();
              const dialogHeight = $dialog.height();
              const left = (windowWidth - dialogWidth) / 2;
              const top = (windowHight - dialogHeight) / 2;
              $dialog.css({
                top: top + 'px',
                left: left + 'px',
              });
            }
          });
        };
        const mutationObserver = new MutationObserver(handleListenChange);
        const options = {
          childList: true,
          subtree: true,
          attributes: true,
        };
        mutationObserver.observe(document.querySelector('#fb-root'), options);
      } catch (e) {
        this.center = false;
        return;
      }
    }
  },
  event() {
    $('.j-fb-share').on('click', () => {
      if (!localStorage.getItem('phone_merge')&&!localStorage.getItem('email')) {
        //没预约 去预约
        popupyy.showPopupyy('getChance');
        return
      }
        this.centerDialog();
        this.shareFB();
    });
  },
  setFinalTime() {
    let finalDate = new Date();
    finalDate.setHours(23)
    finalDate.setMinutes(59);
    localStorage.setItem('shareTime', finalDate.getTime());
  },
  getShareTimeToHide() {
    if (localStorage.getItem('shareTime') == null) {
      return false;
    }
    let finalTime = localStorage.getItem('shareTime') * 1;
    let finalDate = new Date(finalTime);
    let curDate = new Date();
    return curDate.getTime() < finalDate.getTime();
  }
};

export const popup = {
    $popup: $('.j-popup'),
    $popupClose: $('.j-popup-close'),
    $btn: $('.j-gofb-btn'),
    $blackShadow: $('.j-black-shadow'),
    event: null,
    closeHandlerBind: null,
    name: '',
  showPopup(name) {
    this.name = name;
    this.closeHandlerBind = this.closeHandler.bind(popup);
      this.$popup.addClass(name);
      this.$blackShadow.fadeIn();
    this.$popup.fadeIn();
    this.$popupClose.on('click', this.closeHandlerBind);
  },
  addEvent(event) {
    event && (this.event = event.bind(popup)) && this.$btn.on('click', this.event);
  },
  closeHandler() {
    this.$popup.hide();
      this.$popup.removeClass(this.name);
      this.$blackShadow.fadeOut();
    this.name = '';
    $(".j-popup-main").html("");
    $(".j-popup-message").html("");
    this.$popupClose.off('click', this.closeHandlerBind);
    this.$btn.off('click', this.event);
  },
};

export const popupyy = {
    $popupyy: $('.j-popup-yy'),
    $popupyyClose: $('.j-yy-close'),
    $goFbbtn: $('.j-gofb-btn'),
    $blackShadow: $('.j-black-shadow'),
    event1: null,
    closeHandlerBind: null,
    name: '',
  showPopupyy(name) {
    this.name = name;
    this.closeHandlerBind = this.closeHandler.bind(popupyy);
      this.$popupyy.addClass(name);
      this.$blackShadow.fadeIn();
    this.$popupyy.fadeIn();
    this.$popupyyClose.on('click', this.closeHandlerBind);
  },
  addEvent(event1) {
    event1 && (this.event1 = event1.bind(popupyy)) && this.$goFbbtn.on('click', this.event1);
  },
  closeHandler() {
      this.$popupyy.hide();
      this.$blackShadow.fadeOut();
    this.$popupyy.removeClass(this.name);
    this.name = '';
    this.$popupyyClose.off('click', this.closeHandlerBind);
    this.$goFbbtn.off('click', this.event1);
  },
};

//更新预约人数
export const preNum = {
  $preNum: $('.j-pre-num'),
  init() {
    this.update();
  },
  update() {
    api
      .doReserve('getReserveNum')
      .then(({ data }) => {
        const num = data.reserveTotal;
        this.$preNum.text(num);
      })
      .catch(err => {
        this.$preNum.text(0);
      });
  },
};

// 首页下载 part1
export const download = {
  fullpageAPI: null,
  toRegisterBind: null,
  toShopBind: null,
  closeHandlerBind: null,
  downType: '',
  init(fullpageAPI) {
    this.fullpageAPI = fullpageAPI;
    this.toRegPageBind = this.toRegPage.bind(this);
    this.event();
  },
  event() {
    $('.j-apple').on('click', ({ target }) => {
      if (language.getLang() == "thai") {
        window.open('https://apps.apple.com/th/app/%C4%91%E1%BA%A5u-la-%C4%91%E1%BA%A1i-l%E1%BB%A5c-h%E1%BB%93ns%C6%B0-%C4%91%E1%BB%91iquy%E1%BA%BFt/id1597681212', '_blank');
        this.downType = target.dataset.shop;
      } else {
        window.open('https://apps.apple.com/vn/app/%C4%91%E1%BA%A5u-la-%C4%91%E1%BA%A1i-l%E1%BB%A5c-h%E1%BB%93ns%C6%B0-%C4%91%E1%BB%91iquy%E1%BA%BFt/id1597681212', '_blank');
        this.downType = target.dataset.shop;
      }
      
    });
    $('.j-google').on('click', ({ target }) => {
      window.open('https://play.google.com/store/apps/details?id=com.global.dl3dvn', '_blank');
      this.downType = target.dataset.shop;
    });
  },
  toRegPage() {
    //统一链接 可能要修改 现在没用到 暂留
    window.open('https://dlssr.onelink.me/5yNJ/gp', '_blank');
  },
};

// 预约 part2
export const register = {
    device: 'android',
    //根据ip默认地区
    area: '',
    //预约方式
    way:'phone',
    code: '',
  //默认勾选服务条款
  check: true,
  init() {
    this.event();
  },
  event() {
    const $device = $('.j-device');
    const $areaList = $('.j-area-list');
    const $area = $('.j-area');
    const $areaSelected = $('.j-area-selected');
    const $areaArrow = $('.j-area-arrow');
      const $wayList = $('.j-way-list');
      const $way = $('.j-way');
      const $waySelected = $('.j-way-selected');
      const $wayArrow = $('.j-way-arrow');
      const $phoneBlock = $('.j-phone-block');
      const $emailBlock = $('.j-email-block');
      const $errTip = $('.j-err-tip'); 
    const $formSubmit = $('.j-form-confirm');
      const $check = $('.j-check');
      const $popupPhone = $('.j-popup-phone');
      const $popupEmail = $('.j-popup-email');
    const $popupPhonehead = $('.j-popup-phonehead');
      const $phone = $('.j-phone');
      const $email = $('.j-email');
    const $phonehead = $('.j-phonehead');
    $check.on('click', () => {
      if (this.check) {
        this.check = false;
        $check.removeClass('active');
      } else {
        this.check = true;
        $check.addClass('active');
      }
    });

    $device.on('click', ({ target }) => {
      const device = target.dataset.device;
      if (device == 'android' || device == 'ios') {
        this.device = device;
        const otherDevice = device == 'android' ? 'ios' : 'android';
        $(`.device-${otherDevice}`).removeClass('active');
        $(target).addClass('active');
      }
    });

    $area.on('click', e => {
      $areaList.toggle();
      $areaArrow.toggleClass('active');
    });

    $areaList.on('click', ({ target }) => {
      $wayList.hide();
      $wayArrow.removeClass('active');
      const area = target.dataset.area;
      const areaArr = [
        'vi',
        'thai',
        'qita',
      ];
      const areaMap = {
        vi: {
          vi: 'Việt Nam',
        thai: 'Thái',
        qita: 'Khác',
        },
        thai: {
          vi: 'เวียดนาม',
        thai: 'ไทย',
        qita: 'อื่นๆ',
        },
        zh: {
          vi: '越南',
        thai: '泰国',
        qita: '其他',
        }
      };
      if (areaArr.includes(area) && area != 'select') {
        this.area = area;
          areaArr.forEach(item => {
            //清空默认
            $areaSelected.html("");
            $areaSelected.removeClass(item);
          });
          //加上选择的地区
        const lang = language.getLang();
        $areaSelected.html(areaMap[lang][area]);
          $areaSelected.addClass(area);
          $areaSelected.attr('data-area', area);
          if (area == 'vi') {
              $wayArrow.hide();
              $waySelected.removeClass("email");
              $waySelected.addClass("phone");
              $waySelected.attr('data-way', "phone");
              $phoneBlock.show();
              $emailBlock.hide();
              //不可点击
            $way.addClass("disabled");
            $waySelected.html(language.getText("phone"));
          } else {
              $wayArrow.show();
              $way.removeClass("disabled");
          }
          if ($areaSelected.attr('data-area')=="vi") {
            $phonehead.html("84");
            $popupPhonehead.html("84");
            $phonehead.attr('contenteditable', 'false');
            $popupPhonehead.attr('contenteditable', 'false');
          } else if ($areaSelected.attr('data-area')=="thai") {
            $phonehead.html("66");
            $popupPhonehead.html("66");
            $phonehead.attr('contenteditable', 'false');
            $popupPhonehead.attr('contenteditable', 'false');
          } else {
            $phonehead.html("");
            $popupPhonehead.html("");
            $phonehead.attr('contenteditable', 'true');
            $popupPhonehead.attr('contenteditable', 'true');
          }
      }
      $areaList.hide();
      $areaArrow.removeClass('active');
    });

    $way.on('click', e => {
        $wayList.toggle();
        $wayArrow.toggleClass('active');
      });
  
    $wayList.on('click', ({ target }) => {
        const way = target.dataset.way;
        const wayArr = [
          'phone',
          'email',
        ];
       
        if (wayArr.includes(way) && way != 'select') {
          this.way = way;
            wayArr.forEach(item => {
              //清空默认
                $waySelected.html("");
                // $waySelected.removeClass(item);
            });
            //加上选择的
            $waySelected.html(language.getText(way));
            $waySelected.attr('data-way', way);
            // $waySelected.addClass(way);
            if ($waySelected.attr('data-way') == 'email') {
                $phoneBlock.hide();
                $emailBlock.show();
            } else {
                $phoneBlock.show();
                $emailBlock.hide();
            } 
        }
        $wayList.hide();
        $wayArrow.removeClass('active');
      });
    $formSubmit.on('click', ({ target }) => {
        if (!this.check) {
          //提示勾选协议
          $(".j-popup-main").html(language.getText("popupTip3"));
          popup.showPopup('common-tip');
        return;
      }
      if (localStorage.getItem('phone_merge')||localStorage.getItem('email')) {
        //已预约
        localStorage.getItem('phone_merge') && $(".j-popup-message").html(localStorage.getItem('phone_merge'));
        localStorage.getItem('email') && $(".j-popup-message").html(localStorage.getItem('email'));
          $(".j-popup-main").html(language.getText("popupTip1"));
          $('.j-popup').removeClass("inschool");
        popup.showPopup('pred');
        return
      }
      const areaMap = {
        vi: '越南',
        thai: '泰国',
        qita: '其他',
      };
    if (this.area === "") {
        this.area = setArea();
        function setArea() { 
          switch (language.getLang()) {
              case "vi": {
                return "vi"
                break
            }
              case "thai": {
                return "thai"
                break
            }
              default:
              //this.area = "qita";
                return "qita"
            }
        }
    }  
        const source = target.dataset.source;
        let phone = '';
        let email = '';
        let phoneCode = ''; 
    if (source === 'popup') {
        phone = $popupPhone.text().trim();
        email = $popupEmail.text().trim();
        phoneCode = $popupPhonehead.html();
    } else {
        phone = $phone.text().trim();
        email = $email.text().trim();
        phoneCode = $phonehead.html();
    }
      if (this.way == 'email') {
            //选择邮箱预约 清空手机号 手机传空值
          phone = '';
          phoneCode = '';
            let emailFormate = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
            if (!emailFormate.test(email)) {
                $errTip.text(language.getText('emailError'));
                $errTip.show();
                setTimeout(() => {
                    $errTip.hide();
                    $errTip.text("");
                }, 5000);
                return;
            }
      } else {
            //选择手机号预约 清空邮箱 邮箱传空值
            email = '';
            // 校验手机格式
            let phoneFormate = {
            //其他无固定规则只判断数字
                vi: /(^0\d{9}$)|(^[1-9]\d{8}$)/,
                thai: /(^0\d{9}$)|(^[1-9]\d{8}$)/,
                qita: /^\d{1,}$/,
            };
            //不知
            // phoneFormate[this.area].lastIndex = 0;
            if (!phoneFormate[this.area].test(phone)) {
                $errTip.text(language.getText('phoneError'));
                $errTip.show();
                setTimeout(() => {
                    $errTip.hide();
                    $errTip.text("");
                }, 5000);
                return;
            }
            //检验国别码不能为空
            if (!phoneCode) {
                $errTip.text(language.getText('phoneError'));
                $errTip.show();
                setTimeout(() => {
                    $errTip.hide();
                    $errTip.text("");
                }, 5000);
                return;
            }
        }
      const submitForm = {
        area: areaMap[this.area],
        device: this.device,
        phone: phone,
        phone_code: phoneCode,
        email: email,
        scid: getParam('scid'),
        cid: getParam('cid'),
      };
      api
        .doReserve('doReserve', submitForm)
        .then(res => {
          const source = target.dataset.source;
          source === 'popup' && popupyy.closeHandlerBind();
          $(".j-popup-main").html("");
          $(".j-popup-message").html("");
          if (source == 'popup'&&$(".j-popup-yy").attr("class").includes("focusGame")) {
              popup.showPopup('registered');
            } else {
                //预约成功弹窗
                popup.showPopup('inschool');
          } 
          //国别码跟号码拼接
            localStorage.setItem('phone_merge',submitForm.phone_code+submitForm.phone);
          localStorage.setItem('email', submitForm.email);
          wakeNum.init();
          dataLayer.push({ 'event': 'reserVationSuccess' });
        })
        .catch(({ code, msg }) => {
            if (code == -254) {
              //此手机号已完成预约
            $(".j-popup-main").html(language.getText("popupTip1"));
            popup.showPopup('pred');
          }
            if (code == -20006 || code == -1006) {
              //活动结束
              $(".j-popup-main").html(language.getText("timeEnd"));
            popup.showPopup('end');
          }
            if (code == -10087 || code == 0) {
              //手机号错误请重新输入
              $errTip.text(language.getText('phoneError'));
              $errTip.show();
                setTimeout(() => {
                    $errTip.hide();
                    $errTip.text("");
                }, 5000);
            }
          dataLayer.push({
            event: 'reservationFail',
            reason: msg
          })
        });
    });
  },
};

// 开启觉醒 part3
export const wake = {
  $popup: $('.j-popup'),
  $popupClose: $('.j-popup-close'),
  $headItem: $('.j-head li'),
  $awardPopup: $('.j-popup-award'),
  $awardClose: $('.j-award-close'),
  $awardBag: $('.j-award-bag'),
  $wakeStep: $('.j-wake-step li'),
  $wakeRule: $('.j-wake-rule'),
    $popupRule: $('.j-popup-rule'),
    $popupPool: $('.j-popup-pool'),
    $ruleClose: $('.j-rule-close'),
    $poolClose: $('.j-pool-close'),
    $blackShadow: $('.j-black-shadow'),
  isMobile: false,
  init(isMobile = false) {
    this.isMobile = isMobile;
    this.wake();
    this.cardDesc();
    this.awardBagEvent();
    this.rule();
  },
  wake() {
    const $wake = $('.j-wake');
    const $wakeStart = $('.j-wake-click');
    const $popupCard = $('.j-popup-card');
    const $cardResult = $('.j-card-result');
    const $cardListItem = $('.j-card-list li');

    const showCardResult = () => {
      // 获取奖励数据
      // 显示结果
      this.$blackShadow.fadeOut();
      $popupCard.fadeOut(() => {
        this.showBag();
        // 移除翻盘效果
        for (let i = 0; i < 30; i++) {
          if (utils.isIE()) {
            $(ele).removeClass(`show-ie-card-${cardArr[index]}`);
          } else {
            utils.whatDevice() == 'mobile'
              ? $cardListItem.removeClass(`show-mcard-${i + 1}`)
              : $cardListItem.removeClass(`show-card-${i + 1}`);
          }
        }
      });
    };
      $wakeStart.on('click', () => {
        if (!localStorage.getItem('phone_merge')&&!localStorage.getItem('email')) {
            //没预约 去预约
            popupyy.showPopupyy('getChance');
            return
        }
        wakeNum.update();
        let remainNum = $('.j-remain-num').html();
        if (remainNum === 0) {
          $(".j-popup-main").html(language.getText("popupTip4"));
          popup.showPopup('common-tip');
          return
        }
          let responseData = null;
          informationForm.phone_merge = localStorage.getItem('phone_merge');
          informationForm.email = localStorage.getItem('email');
      Promise.resolve()
        // 请求数据
        .then(() => {
          return api.req('lottery',informationForm);
        })
        // 暂存请求数据
        .then(({ data }) => {
          responseData = data;
        })
        // 觉醒放大
        .then(() => {
          $wake.addClass('scale');
        })
        // 显示卡牌弹窗后还原觉醒球
        .then(() => {
          const p = new Promise((resolve) => {
              const showPopupAndResetBall = () => {
                this.$blackShadow.fadeIn();
                $popupCard.fadeIn(() => {
                $wake.removeClass('scale');
                resolve();
              });
            }
            setTimeout(showPopupAndResetBall, 600)
          })
          return p;
        })
        // 更新觉醒次数
        .then(() => {
          wakeNum.update();
        })
        // 翻卡牌
        .then(() => {
          const p = new Promise((resolve) => {
            const cardArr = responseData.showCardIds;
            let preClassName = '';
            if (utils.isIE()) {
              // 判断是否是IE，特效降级
              preClassName = 'show-ie-card-';
            } else if (utils.whatDevice() == 'mobile') {
              // 移动端
              preClassName = 'show-mcard-';
            } else {
              // PC端
              preClassName = 'show-card-';
            }
            const cb = (index, ele) => {
              setTimeout(() => {
                $(ele).addClass(`${preClassName}${cardArr[index]}`)
                // 到最后一张了
                index == 9 && resolve();
              }, index * 300);
            }
            $cardListItem.each(cb);
          })
          return p;
        })
        // 动画完成，注册事件可以查看背包
        .then(() => {
          $(document).one('click', () => {
            showCardResult();
          });
          $cardResult.one('click', () => {
            showCardResult();
          });
        })
        // 异常处理
        .catch(({ code, msg }) => {
          switch (code) {
            case -20013:
              // 活动已结束
              $(".j-popup-main").html(language.getText("timeEnd"));
              popup.showPopup('common-tip');
              break;
            case -20002:
              // 活动未结束-觉醒次数不足
              $(".j-popup-main").html(language.getText("popupTip4"));
              popup.showPopup('common-tip');
              break;
            default:
              //请稍后再试
              $(".j-popup-main").html(language.getText("popupTip5"));
              popup.showPopup('common-tip');
              // alert(msg);
          }
        })
    });
  },
  rule() {
    this.$wakeRule.on('click', () => {
      // 关闭gift
        this.$popupPool.fadeOut();
        this.$blackShadow.fadeIn();
        this.$popupRule.fadeIn();
        
    });
    this.$ruleClose.on('click', () => {
        this.$popupRule.fadeOut();
        this.$blackShadow.fadeOut();
    });
  },
  cardDesc() {
    $('.j-gift').on('click', () => {
      // 关闭rule
        this.$popupRule.fadeOut();
        this.$blackShadow.fadeIn();
        this.$popupPool.fadeIn();
    });
    this.$poolClose.on('click', () => {
        this.$popupPool.fadeOut();
        this.$blackShadow.fadeOut();
    });
  },
  awardBagEvent() {
    this.$awardBag.on('click', () => {
      if (!localStorage.getItem('phone_merge')&&!localStorage.getItem('email')) {
        //没预约 去预约
        popupyy.showPopupyy('getChance');
        return
      }
        this.showBag();
    });
      this.$awardClose.on('click', () => {
        this.$blackShadow.fadeOut();
      this.$awardPopup.fadeOut(() => {
        this.$headItem
          .removeClass('active')
          .removeClass('hide-lock')
          .removeClass('ie-active');
        this.$wakeStep.find('span').attr('class', '');
      });
    });
  },
  showBag() {
    // 关闭rule
    this.$popupRule.fadeOut();
    // 关闭gift
      this.$popupPool.fadeOut();
      this.$blackShadow.fadeIn();
      this.$awardPopup.fadeIn(() => {
        
      api
        .req('award_log',informationForm)
        .then(({ data }) => {
          const ssrCardIds = data.ssrCardIds;
          // 显示结果
          const headMap = {
            1: 3,
            2: 2,
            3: 5,
            4: 1,
            5: 7,
            6: 4,
            7: 6,
          };
          const step = ssrCardIds.length;
          for (let i = 0; i < 4; i++) {
            const $span = this.$wakeStep.eq(i).find('span');
            // console.log($span.data('step'));
            $span.data('step') <= step
              ? $span.addClass('award-got')
              : $span.addClass('award-get');
          }
          ssrCardIds.forEach(item => {
            const head = this.$headItem.eq(headMap[item + ''] - 1);
            // 兼容IE
            utils.isIE() ? head.addClass('ie-active') : head.addClass('active');
            setTimeout(() => {
              head.addClass('hide-lock');
            }, 300);
          });
        })
        .catch(err => {
          // console.log(err);
        });
    });
  },
};

//游戏介绍 part5
export const world = {
  $baseNav: $('.j-base-nav li'),
  $textList: $('.j-text li'),
  curSection: 'role',
  showingText: false,
  curText: 1,
  timerArr: [],
  init() {
    this.event();
  },
  event() {
    //  模块切换
    $('.j-btn-section').on('click', ({ target }) => {
      const section = target.dataset.section;
      if (this.curSection == section) {
        return;
      }
      this.clearText();
      if (section == 'base') {
        this.showText();
        }
    if (section == 'features') {
        // 轮播图初始化
        const shopSwiper = new Swiper('.part5 .part5-features .swiper-container', {
        watchSlidesProgress: true,
        slidesPerView: 'auto',
        centeredSlides: true,
        loop: true,
        loopedSlides: 5,
        autoplay: true,
        navigation: {
          nextEl: '.part5 .part5-features .swiper-button-next',
          prevEl: '.part5 .part5-features .swiper-button-prev',
        },
        pagination: {
          el: '.part5 .part5-features .swiper-pagination',
          clickable: true,
        },
        on: {
          progress: function (progress) {
            for (let i = 0; i < this.slides.length; i++) {
              var slide = this.slides.eq(i);
              var slideProgress = this.slides[i].progress;
              let modify = 1;
              if (Math.abs(slideProgress) > 1) {
                modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
              }
              let translate = ((slideProgress * modify * 442) / 1080) * 100 + 'vh';
              let scale = 1 - Math.abs(slideProgress) / 5;
              let zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
              slide.transform('translateX(' + translate + ') scale(' + scale + ')');
              slide.css('zIndex', zIndex);
              slide.css('opacity', 1);
              if (Math.abs(slideProgress) > 3) {
                slide.css('opacity', 0);
              }
            }
          },
          setTransition: function (transition) {
            for (var i = 0; i < this.slides.length; i++) {
              var slide = this.slides.eq(i);
              slide.transition(transition);
            }
          },
          resize() {
            let width = $('.part5 .part5-features .swiper-container').width();
            $('.part5 .part5-features .swiper-container img').css('width', `${width}px`);
          },
        },
        });
        setTimeout(() => {
            shopSwiper.update();
          }, 10);
    }
      const sectionArr = ['base', 'role', 'map', 'features'];
      const sectionPart = [
        {
          section: 'base',
          ele: $('.j-part5-base'),
        },
        {
          section: 'role',
          ele: $('.j-part5-role'),
        },
        {
          section: 'map',
          ele: $('.j-part5-map'),
        },
        {
          section: 'features',
          ele: $('.j-part5-features'),
        },
      ];
      if (sectionArr.includes(section)) {
        this.curSection = section;
        sectionPart.forEach(item => {
          if (item.section == section) {
            item.ele.fadeIn();
          } else {
            item.ele.fadeOut();
          }
        });
      }
    });
    // 文字切换
    $('.j-base-nav').on('click', ({ target }) => {
      const nav = target.dataset.nav * 1;
      this.changeText(nav);
    });
  },
  changeText(nav) {
    if (this.curText == nav) {
      return;
    }
    this.curText = nav;
    if (nav <= 4 || nav >= 1) {
      this.$baseNav
        .removeClass('active')
        .eq(nav - 1)
        .addClass('active');
      this.$textList
        .hide()
        .eq(nav - 1)
        .show();
      this.$textList.find('p').removeClass('active');
      const $p = this.$textList.eq(nav - 1).find('p');
      this.timerArr.forEach(item => {
        clearTimeout(item);
      });
      this.timerArr = [];
      $p.each((index, ele) => {
        const timer = setTimeout(() => {
          $(ele).addClass('active');
        }, 300 * index);
        this.timerArr.push(timer);
      });
    }
  },
  clearText() {
    this.timerArr.forEach(item => {
      clearTimeout(item);
    });
    this.$textList.find('p').removeClass('active');
  },
  showText() {
    const $p = this.$textList.eq(this.curText - 1).find('p');
    this.timerArr.forEach(item => {
      clearTimeout(item);
    });
    this.timerArr = [];
    $p.each((index, ele) => {
      const timer = setTimeout(() => {
        $(ele).addClass('active');
      }, 300 * index);
      this.timerArr.push(timer);
    });
  },
};

// 人物切换 part5
export const role = {
  $roleHead: $('.j-role-head'),
  $roleItem: $('.j-role-item'),
  $roleMain: $('.j-role-main'),
  $roleMain1: $('.j-role-main-1'),
  $roleMain2: $('.j-role-main-2'),
  init() {
    this.event();
  },
  event() {
    this.$roleHead.on('click', ({ target }) => {
      const role = target.dataset.role;
      const roles = [
        'ningrongrong',
        'aosika',
        'daimubai',
        'tangsan',
        'xiaowu',
        'zhuzhuqing',
        'mahongjun',
      ];
      if (roles.includes(role)) {
        if (this.$roleMain2.hasClass(role)) {
          return;
        }
        roles.forEach(item => {
          this.$roleItem.removeClass('active');
          this.$roleMain1.removeClass(item);
        });
        $(target).addClass('active');
        this.$roleMain1.addClass(role);
        this.$roleMain.css({
          transform: 'translateX(0)',
          transition: 'transform .3s',
        });
        setTimeout(() => {
          roles.forEach(item => {
            this.$roleMain2.removeClass(item);
          });
          this.$roleMain2.addClass(role);
          this.$roleMain.css({
            transform: 'translateX(-50%)',
            transition: 'transform 0s',
          });
        }, 300);
      }
    });
  },
};
//part4
export const activities = {
    $goFbPopup: $('.j-go-fb-btn'),
    init() {
        this.event();
    },
    event() {
        this.$goFbPopup.on('click', () => {
            popup.addEvent(() => {
                if (language.getLang() === 'thai') {
                    window.open("https://www.facebook.com/DouLuoDalu3D.TH/");
                } else {
                    window.open("https://www.facebook.com/DauLaDaiLuc3D.VN/");
                }
      		    popup.closeHandlerBind();
            });
            popupyy.addEvent(() => {
                    if (language.getLang() === 'thai') {
                        window.open("https://www.facebook.com/DouLuoDalu3D.TH/");
                    } else {
                        window.open("https://www.facebook.com/DauLaDaiLuc3D.VN/");
                    }
                    popupyy.closeHandlerBind();
      	        });
            if (!localStorage.getItem('phone_merge')&&!localStorage.getItem('email')) {
                //没预约去预约
                popupyy.showPopupyy('focusGame');
            } else {
                if (language.getLang() === 'thai') {
                    window.open("https://www.facebook.com/DouLuoDalu3D.TH/");
                } else {
                    window.open("https://www.facebook.com/DauLaDaiLuc3D.VN/");
                }
            }
        });
    },
};

export const footer = {
  $footer: $('.j-footer'),
  init() {
    $('.j-copyright').on('click', () => {
      this.$footer.toggleClass('active');
    });
  },
};

export const initFullPage = function () {
  const fullpageAPI = new fullpage('#fullpage', {
    licenseKey: 'OPEN-SOURCE-GPLV3-LICENSE',
    autoScrolling: true,
    scrollHorizontally: true,
    afterLoad: function (origin, destination) {
      if (!initPage) {
        initPage = true;
        return;
      }
      const index = destination.index;
      // 导航栏展开
      if (!menuHasClick) {
        menuHasClick = true;
        const $nav = $('.j-nav');
        index == 0 ? $nav.removeClass('active') : $nav.addClass('active');
      }
      // 导航栏高亮显示
      const $navList = $('.j-desc-list li');
      $navList.removeClass('active').eq(index).addClass('active');
      // 注意事项文字动效
      const $attention = $('.j-attention');
      index == 5
        ? $attention.addClass('slide-out')
        : $attention.removeClass('slide-out');
      // 底部滚动提示
      const $mouse = $('.j-part-mouse');
      const $bottom = $(".j-bottom");
      index == 5 ? $mouse.fadeOut() : $mouse.fadeIn();
      // 文字动效
      index == 4 ? world.showText() : world.clearText();
      //左侧商店链2,3,4页展示
      index == 1||index == 2||index == 3 ? $bottom.fadeIn() : $bottom.fadeOut();
    },
  });
  return fullpageAPI;
};
